export default __webpack_public_path__ + "static/media/foot-traffic.cc2e226c.png";